module.exports = __webpack_public_path__ + "static/media/200472.437061bb.jpg";